import apiService from './ApiService';

// Instancias de evaluación de colegio (por materia del curso). Ver BE.API/Controllers/EvaluacionesController.cs.
class EvaluacionesService {
  getMateriasEvaluables(idCurso) {
    return apiService.get(`/evaluaciones/cursos/${encodeURIComponent(idCurso)}/materias`);
  }

  getEvaluaciones(idCursoMateria) {
    return apiService.get(`/evaluaciones/cursos-materias/${encodeURIComponent(idCursoMateria)}`);
  }

  createEvaluacion(idCursoMateria, payload) {
    return apiService.post(`/evaluaciones/cursos-materias/${encodeURIComponent(idCursoMateria)}`, payload);
  }

  updateEvaluacion(id, payload) {
    return apiService.put(`/evaluaciones/${encodeURIComponent(id)}`, payload);
  }

  deleteEvaluacion(id) {
    return apiService.delete(`/evaluaciones/${encodeURIComponent(id)}`);
  }

  getPlanilla(id) {
    return apiService.get(`/evaluaciones/${encodeURIComponent(id)}/planilla`);
  }

  guardarNota(id, idAlumno, payload) {
    return apiService.put(`/evaluaciones/${encodeURIComponent(id)}/notas/${encodeURIComponent(idAlumno)}`, payload);
  }

  getResumen(idCurso, idCursoMateria = null) {
    const qs = idCursoMateria ? `?idCursoMateria=${encodeURIComponent(idCursoMateria)}` : '';
    return apiService.get(`/evaluaciones/cursos/${encodeURIComponent(idCurso)}/resumen${qs}`);
  }
}

const evaluacionesService = new EvaluacionesService();

export default evaluacionesService;
